module.exports = __webpack_public_path__ + "static/ocean-marine-insurance-2d840a43a858f97f2ae2a211e2da10c0.svg";